import React, { FC } from 'react';

import { BUTTON_TYPES, EvButton, EvSelectNew, OptionType } from '@evinced-private/ui-common';

interface IPerformanceOverTimeSelectGroup {
	selectedViews: OptionType[];
	onMultiViewSelect: (values: OptionType[]) => void;
	viewsOptions: OptionType[];
	isApplyButtonDisabled: boolean;
	onApplyView: () => void;
}

export const PerformanceOverTimeSelectGroup: FC<IPerformanceOverTimeSelectGroup> = ({
	selectedViews,
	onMultiViewSelect,
	viewsOptions,
	isApplyButtonDisabled,
	onApplyView
}) => {
	return (
		<div className="select-group">
			<EvSelectNew
				id="performance-over-time-select-views"
				options={viewsOptions}
				selectedValue={selectedViews}
				onSelectChange={onMultiViewSelect}
				placeholder="Select views"
				label="Views"
			/>
			<EvButton
				disabled={isApplyButtonDisabled}
				type={BUTTON_TYPES.SECONDARY}
				onClick={onApplyView}
			>
				Apply
			</EvButton>
		</div>
	);
};
